import Http from '@/api/http.js'

export default {

  index(filter) {
    return Http.get(`/modalities`, {params: filter})
  },
  indexByCurrentUser() {
    return Http.get(`/modalities`, {params: {index_by_current_user: true}})
  },

  create(modality){
    const {document, address, contact, ...d} = modality
    return Http.post(`/modalities`, {
      modality: {
        ...d,
        document: document.replace(/[\W]/g, ""),

        address_attributes: address,
        contact_attributes: contact,
      }
    })
  },

  update(modality){
    return Http.put(`/modalities/${modality.id}`, {
      modality: {
        ...modality,
        document: modality.document.replace(/[\W]/g, ""),
      },
    });
  },
  defaultUpdate(modality){
    return Http.put(`/modalities/${modality.id}`, {
      modality
    });
  },
  addEmployees(id, employee_ids){
    return Http.put(`/modalities/${id}/add_employees`, { employee_ids })
  },
  removeEmployees(id, employee_ids){
    return Http.put(`/modalities/${id}/remove_employees`, { employee_ids })
  },

  show(id) {
    return Http.get(`/modalities/${id}`);
  },

  delete(id){
    // return Http.delete(`/modalities/${id}`)
  }

}
